import { Link } from 'react-router-dom';

const Footer = () => {
  const footerLinks = {
    company: [
      { name: '会社概要', path: '/company' },
      { name: '事業内容', path: '/services' },
      { name: 'お問い合わせ', path: '/contact' },
      { name: 'Privacy Policy', path: '/privacy-policy' },
    ],
    services: [
      { name: 'ITコンサルティング', path: '/services' },
      { name: 'SES事業', path: '/services' },
      { name: 'アプリ開発', path: '/services' },
    ],
  };

  return (
    <footer className="bg-darkgray text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 400" fill="none">
          <path
            d="M100 200 Q 300 100, 500 200 T 900 200 T 1300 200"
            stroke="#A8C3A3"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </div>

      <div className="relative px-8 lg:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/4df5c7deddaddbbeeb26e7a7cacf2afd/4cd226bf6ea29e5396bf472c029eb795.png" 
                alt="SINAX Logo" 
                className="h-24 w-auto brightness-0 invert"
              />
              <h3 className="font-serif text-xl tracking-wider">SINAX</h3>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed mb-8">
              縁を軸に、ITと現場をつなぎ、<br />
              共に未来の形をつくる。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-sans text-sm tracking-wide mb-4 text-warmgray">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-sans text-sm tracking-wide mb-4 text-warmgray">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-center items-center gap-4">
          <p className="text-xs text-gray-400">© 2025 SINAX Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
